import React, { useContext, useEffect, useState } from 'react';
import { PContext } from '../context/PendingContext';
import { Utils } from '../context/UtilsContext';
import Layout from '../layout/Layout';
import PendingListTable   from '../components/PendingList/PendingListTable';
import Filter             from '../components/Filter/Filter';
import PrInformationModal from '../components/PrInformation/PrInformationModal';
import RemarksModal       from '../components/Remarks/RemarksModal';

/* ══════════════════════════════════════════════════════════════
 * THE FIX IS HERE:
 *   search: 'pr'      ← default na may value para lumabas data
 *   status: 'PENDING' ← default status (katulad ng screenshot)
 *   sort:   null      ← latest record (default ng server)
 *
 * Ang useEffect sa ibaba ay direktang nag-pass ng defaultFilter
 * sa getpendingApprovalList — walang stale closure, works 100%.
 * ══════════════════════════════════════════════════════════════ */
const defaultFilter = {
  sort:   null,
  search: 'po',       // ← DATI: '' (empty) — kaya walang data
  status: 'PENDING',  // ← pre-selected sa dropdown
};

const PendingPrView = () => {
  const {
    values,
    getpendingApprovalList,
    getSpoDetails,
    approveOrReject,
    updateRemarks,
  } = useContext(PContext);

  const { setLoading } = useContext(Utils);

  const [filter,      setFilter]      = useState(defaultFilter);
  const [paginate,    setPaginate]    = useState({ page: 1, pageSize: 10 });
  const [modalData,   setModalData]   = useState({ visible: false, data: {} });
  const [remarksData, setRemarksData] = useState({ visible: false, data: {} });

  /* ── Pagination helpers ── */
  const resetPagination = () => setPaginate({ page: 1, pageSize: 10 });

  const onResetFilter = () => {
    setFilter(defaultFilter);
    resetPagination();
    getpendingApprovalList(setLoading, defaultFilter); // direct pass — no stale closure
  };

  const onFilter = () => {
    getpendingApprovalList(setLoading, filter);
    resetPagination();
  };

  const shouldFetchFromServer = ({ page, pageSize }) => {
    const totalData        = page * pageSize;
    const currentDataLength = values.poList.length;
    const dataTotalLength   = values.poListLength;
    let shouldReload = false;

    if (
      totalData > currentDataLength &&
      (dataTotalLength > totalData ||
        (dataTotalLength > totalData - pageSize &&
          dataTotalLength > currentDataLength))
    ) {
      shouldReload = true;
    }

    const shouldLoadAll =
      (totalData > dataTotalLength && dataTotalLength > totalData - pageSize) ||
      totalData === dataTotalLength
        ? `&start=${currentDataLength}&end=${dataTotalLength}`
        : ``;

    return {
      shouldReload,
      newPage: Math.floor(currentDataLength / 1000) + 1,
      shouldLoadAll,
    };
  };

  const onPageChange = (page, pageSize) => {
    const { shouldReload, newPage, shouldLoadAll } = shouldFetchFromServer({ page, pageSize });
    if (shouldReload) getpendingApprovalList(setLoading, filter, newPage, shouldLoadAll);
    setPaginate({ page, pageSize });
  };

  const onSizeChange = (page, pageSize) => {
    const { shouldReload, newPage, shouldLoadAll } = shouldFetchFromServer({ page, pageSize });
    if (shouldReload) getpendingApprovalList(setLoading, filter, newPage, shouldLoadAll);
    setPaginate({ page, pageSize });
  };

  const openModal = (data, type) => {
    if (type === 'pr')      setModalData({   visible: true, data });
    if (type === 'remarks') setRemarksData({ visible: true, data });
  };

  const closeModal = type => {
    if (type === 'pr')      setModalData({   visible: false, data: {} });
    if (type === 'remarks') setRemarksData({ visible: false, data: {} });
  };

  /* ── Auto-load on mount: pass defaultFilter directly ── */
  useEffect(() => {
    getpendingApprovalList(setLoading, defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { poList } = values;

  return (
    <>
      <br />
      <h2>PENDING PO LIST</h2>

      <Filter
        onResetFilter={onResetFilter}
        onFilter={onFilter}
        filter={filter}
        setFilter={setFilter}
      />

      <PendingListTable
        poList={poList}
        openModal={openModal}
        approveOrReject={approveOrReject}
        updateRemarks={updateRemarks}
        setLoading={setLoading}
        paginate={paginate}
        onSizeChange={onSizeChange}
        onPageChange={onPageChange}
        recordLength={values.poListLength}
      />

      {modalData.visible && (
        <PrInformationModal
          visible={modalData.visible}
          data={modalData.data}
          closeModal={closeModal}
          getSpoDetails={getSpoDetails}
        />
      )}

      {remarksData.visible && (
        <RemarksModal
          visible={remarksData.visible}
          data={remarksData.data}
          closeModal={closeModal}
          updateRemarks={updateRemarks}
          setLoading={setLoading}
        />
      )}
    </>
  );
};

export default Layout(PendingPrView);